import sortFunctionMap from "./sortFunctionMap";

export default ({ tasksToSort, sortOrder, mindset }) => {
  const sortFunction =
    sortFunctionMap[sortOrder] || sortFunctionMap["adaptive"];
  return tasksToSort.sort(sortFunction({ mindset }));
};
